<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg">

        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("button.addDefaultTask") }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <form @submit.prevent="submitForm" class="form">
            <div class="modal-body">
              <RequiredText />
              <div class="row pb-3 mb-4">
                <div class="col-12 my-2">
                  <SwitchInput
                      :id="`${id}-task-beReview`"
                      :label="$t('tasks.label.beReview')"
                      v-model="taskForm.need_review"
                      img="/assets/media/tasks/review.png"
                      img-class="ms-2 h-15px"
                  />
                </div>
                <Input
                    container-class="form-group col-12 col-md-5 mt-5 "
                    :name="`project-type-percent`"
                    labelClass="form-label fs-6 text-black"
                    :label="$t('tasks.label.title')"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true"
                    size="lg"
                    :placeholder="''"
                    v-model="taskForm.title"
                  />
                <Select2
                  :parent-id="'#'+id"
                  :is-required="true"
                  container-class="col-12 col-md-3 mt-5"
                  :multiple="false"
                  :show-search="true"
                  :name="`${id}-task-prority`"
                  :label="$t('tasks.label.priority')"
                  label-class="form-label"
                  v-model="taskForm.task_priority_id"
                  :IsInputGroup="true"
                  icon="bi bi-plus"
                  :clickAddon="openPriorityModal"
                >
                  <option v-for="priority in priorities" :value="priority?.id" :key="priority?.id">
                      {{ priority.title }}
                  </option>
                </Select2>
                <Input
                    container-class="form-group col-12 col-md-3 mt-5 "
                    :name="`project-type-delay_value`"
                    type="number"
                    labelClass="form-label fs-6 text-black"
                    :label="$t('projectTypes.label.delay')"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    :placeholder="''"
                    v-model="taskForm.delay_value"
                    :IsInputGroup="true"
                    :is-required="false"
                    :min="1">
                  <template #rightAddon>
                    <Select2
                      container-class="form-group "
                        :multiple="false"
                        :show-search="false"
                        label-class="form-label fs-6 text-black"
                        :selectClass="'form-select form-control-sm form-select-solid rounded-start-0 w-75px'"
                        :name="`projectTypes-delay-unit-id`+id"
                        :is-required="false"
                        v-model="taskForm.delay_unit">
                      <option v-for="(frequency, index) in recurringFrequencyEnum" :value="frequency.value" :key="index">
                        {{ frequency[locale] }}
                      </option>
                    </Select2>
                  </template>
                </Input>
                <div class="col-md-1 align-self-stretch d-flex">
                  <button @click.prevent="toggleAlertModal" class="btn btn-icon btn-primary mt-auto mb-4">
                    <i class="bi bi-gear-fill fs-1"></i>
                  </button>
                </div>

                <div class=" mt-4">
                  <div class="form-group">
                    <label class="form-label fs-6 text-black">{{ $t('tasks.label.checklist') }}</label>
                    <textarea v-model="text" class="form-control form-control-solid" rows="3"></textarea>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                  <Button btn-class="btn-sm me-3" type="cancel" id="submit_clear" btn-text="button.clear" size="7px 30px" @click.prevent="clearForm"></Button>
                  <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.validate" size="7px 30px" ></Button>
                </div>
              </div>
              <hr>
              <div v-for="(task, key) in tasksFormData" :key="key">
                <div class="py-0 px-5" style="background-color: #0072CE0D; margin-bottom: 10px; border-radius: 8px;">
                  <div class="py-1 d-flex flex-stack flex-wrap">
                    <div class="d-flex align-items-center collapsible rotate" data-bs-toggle="collapse" :href="'#task-checklist-accordion-' + id + key" role="button" aria-expanded="false" :aria-controls="'task-checklist-accordion-' + id + key">
                      <div class="me-3 rotate-90">
                        <span class="svg-icon svg-icon-3">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z" fill="currentColor" />
                          </svg>
                        </span>
                      </div>
                      <div class="me-3">
                        <div class="d-flex align-items-center">
                          {{ task?.title }}
                          <img v-if="task.need_review" class="h-15px mx-2" src="/assets/media/tasks/review.png" alt="review">
                          {{ (task?.delay_unit_alert || task?.delay_value_critical) && '|' }} <span class="text-warning mx-4" v-if="task?.delay_unit_alert"> <i class="fa fa-clock text-warning">  </i> {{ task?.delay_value_alert }} {{ $t(task?.delay_unit_alert)}} </span>
                          <span class="text-danger" v-if="task?.delay_value_critical"> <i class="fa fa-notes-medical text-danger">  </i> {{ task?.delay_value_critical }} {{ $t(task?.delay_unit_critical) }} </span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex my-3 ms-9">
                      <button class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" @click.prevent="editTask(key)">
                          <span :title="$t('button.edit')">
                            <i class="fa fa-edit"></i>
                          </span>
                      </button>
                      <button @click.prevent="removeTask(key)" class="btn btn-icon btn-active-light-primary w-30px h-30px me-3" :title="$t('button.delete')" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                        <i class="fa fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div :id="'task-checklist-accordion-' + id +key" :class="key === 0 ? 'show' : ''" class="collapse  fs-6 ps-10" >
                    <div class="row py-5">
                      <div class="col-12 mb-4" v-for="(check, i) in task?.checklists" :key="i">
                        <div class="d-flex align-items-center ps-10 mb-n1">
                          <span class="bullet me-3"></span>
                          <div class="text-gray-600 fw-bold fs-6">{{check?.title}}</div>
                          <span v-if="check.delay_value_alert" class="text-warning mx-4"> <i class="fa fa-clock text-warning">  </i> {{ check?.delay_value_alert }} {{ $t(check?.delay_unit_alert)}} </span>
                          <span v-if="check.delay_value_critical" class="text-danger"> <i class="fa fa-notes-medical text-danger">  </i> {{ check?.delay_value_critical }} {{ $t(check?.delay_unit_critical) }} </span>
                          <i @click.prevent="() => toggleChecklistAlertModal(key, i)" class="bi bi-gear-fill ms-auto me-10"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="new" id="btn" btn-text="button.save" size="7px 30px" @click.prevent="onFinish"></Button>
          </div>
        </div>

    </div>
  </div>
  <PriorityModal :id="'task-step-modal'+id" :parent="id" @priorityCreated="priorityCreated"/>
  <ReminderConfigModal :id="'alert-config-modal'+id" :form="taskForm" :parent="id" @addConfig="getTaskConfig" />
  <ReminderConfigModal :id="'checklist-alert-config-modal'+id" :form="reminderData" :parent="id" @addConfig="getCheckListConfig" />
</template>

<script setup>
import {ref, defineEmits, defineProps, computed, watch,} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue"
import RequiredText from "@/components/RequiredText.vue";
import Select2 from "@/components/Select2.vue";
import { useLocales } from "@/composables/locales";
import { useSwal } from "@/composables/useSwal";
import PriorityModal from "../Modals/PriorityModal.vue";
import ReminderConfigModal from "@/Modules/Projects/components/Modals/ReminderConfigModal.vue";
import SwitchInput from "@/components/SwitchInput.vue";


const store = useStore()
const {locale} = useLocales()
const {showSwal} = useSwal()

const emits = defineEmits(['save'])
const props = defineProps({
  id: String,
  data: {
    type: Array,
    default: () => ([{
      title : "",
      task_priority_id: '',
      delay_value : "",
      delay_unit: '',
      delay_value_alert: "",
      delay_unit_alert: "",
      delay_value_critical: "",
      delay_unit_critical: "",
      checklists: []
    }])
  },
})
const isLoading = ref(false)

const text = ref("");
const current = ref("");

const tasksFormData = ref([...props.data]);
const taskForm = ref({
    title : "",
    delay_value : "",
    delay_unit: '',
    task_priority_id: '',
    checklists: [],
    delay_value_alert: "",
    delay_unit_alert: "",
    delay_value_critical: "",
    delay_unit_critical: "",
    need_review: false
  })

const configCheckList = ref({
  taskIndex: 0,
  index: 0
})
const reminderData= ref({
  delay_value_alert: "",
  delay_unit_alert: "",
  delay_value_critical: "",
  delay_unit_critical: ""
})

const recurringFrequencyEnum = computed(() => store.getters["configs/getFrequencyEnum"])
const priorities = computed(() => store.getters['taskPriorities/getTaskPriorities'])
const lines = computed(() =>
  text.value
    .trim()
    ? text.value
        .split("\n")
        .map((line) =>
          line.trim() !== "" ? { title: line.trim(), id: line?.id ?? null } : null
        )
        .filter(Boolean)
    : []
);

watch(() => props.data, (val) => {
  if (val && val.length) {
    tasksFormData.value = [...val]
  }
})


const priorityCreated = (id) => {
  taskForm.value.task_priority_id = id
}

const openPriorityModal = () => {
  $('#'+props.id).modal('toggle')
  $('#task-step-modal'+props.id).modal('toggle')
}
function closeModal(){
  $('#'+props.id).modal('toggle')
}

function submitForm() {
  const newTask = { ...taskForm.value, checklists: lines.value }

  if(current.value !== '' && current.value !== null) {
    tasksFormData.value[current.value] = newTask
  } else {
    tasksFormData.value.push(newTask)
  }


  taskForm.value = {
    title : "",
    delay_value : "",
    delay_unit: '',
    task_priority_id: '',
    checklists: [],
    delay_value_alert: "",
    delay_unit_alert: "",
    delay_value_critical: "",
    delay_unit_critical: "",
    need_review: false
  }

  text.value = ''
  current.value = ''
}

function removeTask(taskIndex){
  if (taskIndex <= tasksFormData.value?.length) {
    tasksFormData.value.splice(taskIndex, 1)
  }
}

function editTask(taskIndex){
  if (taskIndex <= tasksFormData.value?.length) {
    current.value = taskIndex
    let data = tasksFormData.value?.[taskIndex]
    taskForm.value = {
      title : data?.title,
      task_priority_id: data?.task_priority_id,
      delay_value : data?.delay_value,
      delay_unit: data?.delay_unit,
      delay_value_alert: data?.delay_value_alert,
      delay_unit_alert: data?.delay_unit_alert,
      delay_value_critical: data?.delay_value_critical,
      delay_unit_critical: data?.delay_unit_critical,
      checklists: data?.checklists,
      need_review: data?.need_review
    }
    text.value = data?.checklists?.map(check => check.title)?.join('\n')
  }
}

function clearForm() {
  taskForm.value = {
    title : "",
    delay_value : "",
    delay_unit: '',
    task_priority_id: '',
    checklists: [],
    need_review: false
  }

  text.value = ''
  current.value = ''
}

function onFinish(){
  emits('save', tasksFormData.value)
  $('#'+props.id).modal('toggle')
}

function toggleAlertModal() {
  $('#'+props.id).modal('toggle')
  $('#alert-config-modal'+props.id).modal('toggle')
}

function getTaskConfig(alertConfig) {
  taskForm.value.delay_value_alert = alertConfig.delay_value_alert
  taskForm.value.delay_unit_alert = alertConfig.delay_unit_alert
  taskForm.value.delay_value_critical = alertConfig.delay_value_critical
  taskForm.value.delay_unit_critical = alertConfig.delay_unit_critical
}

function toggleChecklistAlertModal(taskIndex, checklistIndex) {
  configCheckList.value.taskIndex = taskIndex
  configCheckList.value.index = checklistIndex
  const oldData = tasksFormData.value[configCheckList.value.taskIndex].checklists[configCheckList.value.index]
  if(oldData) {
    reminderData.value = { ...oldData }
  }
  $('#'+props.id).modal('toggle')
  $('#checklist-alert-config-modal'+props.id).modal('toggle')
}

function getCheckListConfig(alertConfig) {
  taskForm.value.checklists[configCheckList.value.index] = {
    delay_value_alert: '',
    delay_unit_alert: '',
    delay_value_critical: '',
    delay_unit_critical: '',
  }

  tasksFormData.value[configCheckList.value.taskIndex].checklists[configCheckList.value.index].delay_value_alert = alertConfig.delay_value_alert
  tasksFormData.value[configCheckList.value.taskIndex].checklists[configCheckList.value.index].delay_unit_alert = alertConfig.delay_unit_alert
  tasksFormData.value[configCheckList.value.taskIndex].checklists[configCheckList.value.index].delay_value_critical = alertConfig.delay_value_critical
  tasksFormData.value[configCheckList.value.taskIndex].checklists[configCheckList.value.index].delay_unit_critical = alertConfig.delay_unit_critical
}

</script>

<style scoped>
.icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper i {
  position: relative;
  font-size: 1.5em;
}

.icon-wrapper .icon-text {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  margin-top: 8px;
}

.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: .625rem !important;
  border-bottom-left-radius: .625rem !important;
}
</style>